import React from "react";
import "./footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="text-center">
          ©{new Date().getFullYear()} karnllp. All Rights Reserved
        </div>
      </footer>
    </>
  );
};

export default Footer;
